// extracted by mini-css-extract-plugin
export default {"chfar-mobile-flight-shop-header":"_5QUXJEoH2CiMdgRYPPvG7Q=="};